// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"6037e784","428":"2ee5d306","838":"b231abed","894":"165d91b1"}[chunkId] + ".chunk.js";
};